import { createAsyncThunk } from '@reduxjs/toolkit';

import { USER_ROLES } from 'constants/common';

import * as api from 'api/methods';

import * as types from './types';

export const getLessonRatings = createAsyncThunk<any, any>(
  types.GET_LESSON_RATINGS,
  async (params: Record<string, any>, { getState }: { getState: any }) => {
    const state = getState() as any;

    const user = state.auth.user;

    const isRootAdmin = user.role === USER_ROLES.ROOT_ADMIN;

    const ratings = isRootAdmin
      ? await api.getLessonsRatings(params)
      : await api.getSchoolLessonRatings({ schoolId: user.schoolId, params });

    return ratings;
  },
);

export const getLessonRatingsByStudentId = createAsyncThunk<any, any>(
  types.GET_LESSON_RATINGS_BY_STUDENT_ID,
  async ({
    studentId,
    ...params
  }: {
    studentId: string;
    params: Record<string, any>;
  }) => {
    const ratings = await api.getLessonsRatingsByStudentId({
      studentId,
      params,
    });

    return ratings;
  },
);
